import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home: React.FC = () => {
  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <h1 className="hero-title">Welcome to Dixon Financial Services</h1>
              <p className="hero-subtitle">
                Dixon Financial Services is a comprehensive financial services firm committed to helping you improve your long-term financial success. Our customized programs are designed to grow, protect, and conserve your wealth by delivering an unprecedented level of personalized service and expertise.
              </p>
              <div className="hero-actions">
                <Link to="/contact" className="btn btn-primary cta-enhanced">
                  Schedule a Consultation
                </Link>
                <Link to="/about" className="btn btn-secondary">
                  Learn More About Us
                </Link>
              </div>
            </div>
            <div className="hero-image">
              <div className="advisor-photo">
                <img src="/rob1.png" alt="Rob Dixon - Financial Advisor" className="advisor-img" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Trust Badges Section */}
      <section className="section section-alt trust-badges">
        <div className="container">
          <h2 className="section-title">Our Credentials</h2>
          <div className="badges-grid">
            <div className="trust-badge">
              <div className="badge-icon">🎓</div>
              <span>Certified Financial Planner</span>
            </div>
            <div className="trust-badge">
              <div className="badge-icon">🏛️</div>
              <span>FINRA Member</span>
            </div>
            <div className="trust-badge">
              <div className="badge-icon">🛡️</div>
              <span>SIPC Protected</span>
            </div>
            <div className="trust-badge">
              <div className="badge-icon">⭐</div>
              <span>30+ Years Experience</span>
            </div>
          </div>
        </div>
      </section>

      {/* Services Overview */}
      <section className="section services-overview">
        <div className="container">
          <h2 className="section-title">Our Services</h2>
          <div className="services-grid">
            <div className="service-card enhanced">
              <div className="service-icon-container">
                <svg className="service-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M13 17V9"/>
                  <path d="M18 17V5"/>
                  <path d="M3 3v16a2 2 0 0 0 2 2h16"/>
                  <path d="M8 17v-3"/>
                </svg>
              </div>
              <h3>Investment Management</h3>
              <p>Professional portfolio design and management with access to top institutional money managers and customized investment strategies.</p>
              <Link to="/services" className="service-link enhanced">
                Learn More
                <svg className="arrow-icon" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </Link>
            </div>
            <div className="service-card enhanced">
              <div className="service-icon-container">
                <svg className="service-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M8 2v4"/>
                  <path d="M16 2v4"/>
                  <rect width="18" height="18" x="3" y="4" rx="2"/>
                  <path d="M3 10h18"/>
                  <path d="m9 16 2 2 4-4"/>
                </svg>
              </div>
              <h3>Retirement Planning</h3>
              <p>Comprehensive retirement income planning to secure your financial future with strategic wealth preservation and distribution strategies.</p>
              <Link to="/services" className="service-link enhanced">
                Learn More
                <svg className="arrow-icon" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </Link>
            </div>
            <div className="service-card enhanced">
              <div className="service-icon-container">
                <svg className="service-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                </svg>
              </div>
              <h3>Insurance & Benefits</h3>
              <p>Protection strategies and benefits planning to safeguard your wealth with comprehensive risk management and insurance solutions.</p>
              <Link to="/services" className="service-link enhanced">
                Learn More
                <svg className="arrow-icon" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="section section-alt cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Secure Your Financial Future?</h2>
            <p>Take the first step towards achieving your financial goals. Schedule a complimentary consultation to discover how we can help you build, protect, and preserve your wealth.</p>
            <div className="cta-actions">
              <Link to="/contact" className="btn btn-primary cta-enhanced large">
                Schedule a Consultation
              </Link>
              <a href="tel:314-961-6100" className="btn btn-secondary large">
                Call (314) 961-6100
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home; 